import React, { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  Alert,
  TouchableOpacity,
} from 'react-native';
// import { SafeAreaView } from 'react-native-safe-area-context';
import { useNavigation } from '@react-navigation/native';

import { useAuth } from '../context/AuthContext';
import { ClienteRegisterForm } from '../services/api';
import Button from '../components/Button';
import Input from '../components/Input';

function LoginScreen(): JSX.Element {
  const navigation = useNavigation();
  const { login, isLoading } = useAuth();

const [formData, setFormData] = useState<{ login: string; password: string }>({
  login: '',
  password: '',
});
const [errors, setErrors] = useState<{ login?: string; password?: string }>({});

const validateForm = (): boolean => {
  const newErrors: { login?: string; password?: string } = {};
  if (!formData.login.trim()) {
    newErrors.login = 'Correo o teléfono es requerido';
  }
  if (!formData.password) {
    newErrors.password = 'La contraseña es requerida';
  } else if (formData.password.length < 6) {
    newErrors.password = 'La contraseña debe tener al menos 6 caracteres';
  }
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  const handleLogin = async () => {
    if (!validateForm()) return;

    try {
      await login(formData);
      // Navigation will be handled by auth state change
    } catch (error: any) {
      Alert.alert(
        'Error de Autenticación',
        error.message || 'No se pudo iniciar sesión. Intenta nuevamente.',
        [{ text: 'OK' }]
      );
    }
  };

const handleInputChange = (field: 'login' | 'password', value: string) => {
  setFormData(prev => ({ ...prev, [field]: value }));
  if (errors[field]) {
    setErrors(prev => ({ ...prev, [field]: undefined }));
  }
};

  const navigateToRegister = () => {
    (navigation as any).navigate('Register');
  };

  return (
    <View style={styles.container}>
      {/* Botón Debug - Solo para desarrollo */}
      <TouchableOpacity 
        style={styles.debugButton}
        onPress={() => (navigation as any).navigate('Debug')}
      >
        <Text style={styles.debugButtonText}>🐛</Text>
      </TouchableOpacity>
      
      <KeyboardAvoidingView
        style={styles.keyboardAvoidingView}
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      >
        <ScrollView
          contentContainerStyle={styles.scrollContent}
          keyboardShouldPersistTaps="handled"
        >
          <View style={styles.header}>
            <Text style={styles.logo}>🏍️</Text>
            <Text style={styles.title}>MotoMarketGT</Text>
            <Text style={styles.subtitle}>
              Encuentra los mejores productos en Guatemala
            </Text>
          </View>

          <View style={styles.form}>
<Input
  label="Correo o Teléfono"
  placeholder="ejemplo@correo.com o 55551234"
  value={formData.login}
  onChangeText={(value: string) => handleInputChange('login', value)}
  error={errors.login}
  keyboardType="default"
  autoCapitalize="none"
  autoCorrect={false}
  leftIcon={<Text style={styles.inputIcon}>📧</Text>}
/>

            <Input
              label="Contraseña"
              placeholder="Ingresa tu contraseña"
              value={formData.password}
              onChangeText={(value: string) => handleInputChange('password', value)}
              error={errors.password}
              showPasswordToggle
              leftIcon={<Text style={styles.inputIcon}>🔒</Text>}
            />

            <Button
              title="Iniciar Sesión"
              onPress={handleLogin}
              loading={isLoading}
              disabled={isLoading}
              style={styles.loginButton}
            />

            <View style={styles.divider}>
              <View style={styles.dividerLine} />
              <Text style={styles.dividerText}>o</Text>
              <View style={styles.dividerLine} />
            </View>

            <Button
              title="Crear Cuenta Nueva"
              onPress={navigateToRegister}
              variant="outline"
              disabled={isLoading}
            />
          </View>

          <View style={styles.footer}>
            <TouchableOpacity>
              <Text style={styles.forgotPassword}>
                ¿Olvidaste tu contraseña?
              </Text>
            </TouchableOpacity>
          </View>

          <View style={styles.demoCredentials}>
            <Text style={styles.demoTitle}>📋 Credenciales de prueba:</Text>
            <Text style={styles.demoText}>Email: admin@motomarketgt.com</Text>
            <Text style={styles.demoText}>Contraseña: password123</Text>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F5F5F5',
  },
  keyboardAvoidingView: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingHorizontal: 24,
    paddingVertical: 32,
  },
  header: {
    alignItems: 'center',
    marginBottom: 40,
  },
  logo: {
    fontSize: 64,
    marginBottom: 16,
  },
  title: {
    fontSize: 28,
    fontWeight: '700',
    color: '#333333',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 16,
    color: '#666666',
    textAlign: 'center',
    lineHeight: 22,
  },
  form: {
    marginBottom: 32,
  },
  inputIcon: {
    fontSize: 16,
  },
  loginButton: {
    marginTop: 8,
    marginBottom: 24,
  },
  divider: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 24,
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: '#E0E0E0',
  },
  dividerText: {
    marginHorizontal: 16,
    fontSize: 14,
    color: '#666666',
  },
  footer: {
    alignItems: 'center',
    marginBottom: 32,
  },
  forgotPassword: {
    fontSize: 14,
    color: '#007AFF',
    fontWeight: '600',
  },
  demoCredentials: {
    backgroundColor: '#FFFFFF',
    padding: 16,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E0E0E0',
  },
  demoTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333333',
    marginBottom: 8,
  },
  demoText: {
    fontSize: 13,
    color: '#666666',
    fontFamily: Platform.OS === 'ios' ? 'Courier' : 'monospace',
  },
  debugButton: {
    position: 'absolute',
    top: 50,
    right: 20,
    zIndex: 1000,
    backgroundColor: '#333',
    borderRadius: 20,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  debugButtonText: {
    fontSize: 20,
  },
});

export default LoginScreen;
